import { Icon, IconSize, TextField, TextFieldSize } from '@bechtel/gds';
import { FC } from 'react';
import { SearchFieldContainer } from './styled';
import { SearchIconProps } from './types';

export const SearchField: FC<SearchIconProps> = ({
  iconSize = IconSize.MEDIUM,
  quickFilterText,
  onChange,
  ...props
}) => {
  const clearInput = () => {
    if (onChange) onChange({ target: { value: '' } } as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <SearchFieldContainer>
      <TextField size={TextFieldSize.MEDIUM} {...props} onChange={onChange} value={quickFilterText} />
      {quickFilterText && (
        <Icon
          size={iconSize}
          icon="close"
          fillColor="gray.600"
          iconStyle="regular"
          onClick={clearInput}
          style={{ cursor: 'pointer', right: '28px' }}
        />
      )}
      <Icon size={iconSize} icon="search" fillColor="blue.800" iconStyle="regular" />
    </SearchFieldContainer>
  );
};
